import { createContext, useContext, useState } from "react";
import { FitViewOptions } from "reactflow";

interface FlowActionsContextType {
  fitView?: (options?: FitViewOptions) => void;
  setFitViewFunction: (fn: (options?: FitViewOptions) => void) => void;
}

const FlowActionsContext = createContext<FlowActionsContextType | undefined>(undefined);

export function useFlowActions() {
  const context = useContext(FlowActionsContext);
  if (!context) {
    throw new Error("useFlowActions must be used within a FlowActionsProvider");
  }
  return context;
}

interface FlowActionsProviderProps {
  children: React.ReactNode;
}

export function FlowActionsProvider({ children }: FlowActionsProviderProps) {
  const [fitView, setFitView] = useState<((options?: FitViewOptions) => void) | undefined>(undefined);

  const setFitViewFunction = (fn: (options?: FitViewOptions) => void) => {
    setFitView(() => fn);
  };

  return (
    <FlowActionsContext.Provider value={{ fitView, setFitViewFunction }}>
      {children}
    </FlowActionsContext.Provider>
  );
}
